import {StandardPageSize} from "@react-pdf/types";
import {Orientation} from "@react-pdf/types/page";

import {FormLabelType} from "../Types";
import {FormPaperColorEnum, FormPrintColorEnum, FormPrintOptionsType} from "../../../Types";

import preview from "../preview.jpg"

export const getPreview = () => {
  return preview
}

export const getDefaultPrintOptions = (): FormPrintOptionsType => {
  return {
    size: 'A4',
    orientation: 'portrait',
    printColor: FormPrintColorEnum.COLOR,
    paperColor: FormPaperColorEnum.YELLOW,
  };
}

export const getDefaultLabel = (size: StandardPageSize, orientation: Orientation): Omit<FormLabelType, 'id'> => {
  return {
    ean: "",
    name: "COTOPHARM® BIO COTON",
    title: "PROMOTION",
    capacity: "180 pads x3",
    discount: "-3€",
    discountSize: getDefaultDiscountSize(orientation),
    discountDetail: "",
    price: "9.99",
    priceSize: getDefaultPriceSize(orientation),
    isPriceEuro: true,
    oldPrice: "12.99",
    icon: "text",
  };
}

export const getDefaultDiscountSize = (orientation: Orientation): number => {
  const themeDiscountBySize = {
    landscape: 146,
    portrait: 120,
  };

  return themeDiscountBySize[orientation];
}

export const getDefaultPriceSize = (orientation: Orientation): number => {
  const themePriceBySize = {
    landscape: 155,
    portrait: 135,
  };

  return themePriceBySize[orientation];
}
